import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A5TransactionsEdit } from "./edit";
import { A5TransactionsNew } from "./new";
import { A5TransactionsTable } from "./table";

export default function A5Transactions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Transactions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A5TransactionsEdit />} />
      <Route index element={<A5TransactionsTable />} />
      <Route path="/new" element={<A5TransactionsNew />} />
    </Routes>
  );
}
